import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { isNative } from '../utils/platform';

const DISMISS_KEY = 'PetsFostering-pwa-install-dismissed';

const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    if (isNative) return undefined;

    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setIsStandalone(standalone);

    if (standalone) return;

    try {
      if (localStorage.getItem(DISMISS_KEY) === '1') return;
    } catch {
      /* private browsing */
    }

    const handleBeforeInstall = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    window.addEventListener('appinstalled', () => {
      setVisible(false);
      setDeferredPrompt(null);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const dismiss = () => {
    setVisible(false);
    setDeferredPrompt(null);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* private browsing */
    }
  };

  const install = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      setVisible(false);
    }

    setDeferredPrompt(null);
  };

  if (isNative || isStandalone || !visible || !deferredPrompt) {
    return null;
  }

  return (
    <div className="pf-pwa-install-banner" role="region" aria-label="Install app">
      <div className="pf-pwa-install-banner__content">
        <Download className="w-5 h-5 shrink-0 text-[var(--pf-accent)]" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-gray-900">Install PetsFostering</p>
          <p className="text-xs text-gray-600">Add to your home screen for quick access</p>
        </div>
        <button type="button" onClick={install} className="pf-pwa-install-banner__cta">
          Install
        </button>
        <button
          type="button"
          onClick={dismiss}
          className="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg"
          aria-label="Dismiss install prompt"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PwaInstallPrompt;
